import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type JoinToChatMutationVariables = Types.Exact<{
  roomId: Types.Scalars['String']['input'];
  participantUri: Types.Scalars['String']['input'];
  displayName: Types.Scalars['String']['input'];
}>;


export type JoinToChatMutation = { __typename?: 'Mutation', joinToGroupChat: { __typename?: 'GenericResult', errors?: string | null, result: string } };

export type SendMessageMutationVariables = Types.Exact<{
  groupMessage: Types.GroupMessage;
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendGroupMessage: { __typename?: 'GenericResult', errors?: string | null, result: string } };

export type UpdateMessageMutationVariables = Types.Exact<{
  user: Types.Scalars['String']['input'];
  content: Types.Scalars['String']['input'];
  messageId: Types.Scalars['String']['input'];
}>;


export type UpdateMessageMutation = { __typename?: 'Mutation', updateMessageContent: { __typename?: 'GenericResult', errors?: string | null, result: string } };

export type SendParticipantCommandMutationVariables = Types.Exact<{
  command: Types.ParticipantCommand;
}>;


export type SendParticipantCommandMutation = { __typename?: 'Mutation', sendParticipantCommand: { __typename?: 'GenericResult', result: string } };

export type FileUploadConfigQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FileUploadConfigQuery = { __typename?: 'Query', serverInfo: { __typename?: 'ServerInfo', fileUpload: { __typename?: 'FileUploadConfig', enabled: boolean, maximumFileSize: number } } };

export type MessagesSubscriptionVariables = Types.Exact<{
  user: Types.Scalars['String']['input'];
  roomId: Types.Scalars['String']['input'];
}>;


export type MessagesSubscription = { __typename?: 'Subscription', message: { __typename?: 'Message', receiver: string, sender: string, date: any, messageId: string, status: number, deleted: number, contentType: Types.ContentType, content?: string | null, updated: any, roomId?: string | null, metaInfo?: any | null } };

export type ChatParticipantInfoSubscriptionVariables = Types.Exact<{
  roomId: Types.Scalars['String']['input'];
}>;


export type ChatParticipantInfoSubscription = { __typename?: 'Subscription', chatParticipantInfo: Array<{ __typename?: 'ChatParticipantInfo', participant: string, isAdmin: boolean, additionalInfo: { __typename?: 'AdditionalInfo', handRaised?: boolean | null, isMuted?: boolean | null, name?: string | null, unmuteAllowed?: boolean | null } }> };


export const JoinToChatDocument = gql`
    mutation JoinToChat($roomId: String!, $participantUri: String!, $displayName: String!) {
  joinToGroupChat(
    roomId: $roomId
    participantUri: $participantUri
    displayName: $displayName
  ) {
    errors
    result
  }
}
    `;
export type JoinToChatMutationFn = Apollo.MutationFunction<JoinToChatMutation, JoinToChatMutationVariables>;

/**
 * __useJoinToChatMutation__
 *
 * To run a mutation, you first call `useJoinToChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinToChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinToChatMutation, { data, loading, error }] = useJoinToChatMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      participantUri: // value for 'participantUri'
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useJoinToChatMutation(baseOptions?: Apollo.MutationHookOptions<JoinToChatMutation, JoinToChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinToChatMutation, JoinToChatMutationVariables>(JoinToChatDocument, options);
      }
export type JoinToChatMutationHookResult = ReturnType<typeof useJoinToChatMutation>;
export type JoinToChatMutationResult = Apollo.MutationResult<JoinToChatMutation>;
export type JoinToChatMutationOptions = Apollo.BaseMutationOptions<JoinToChatMutation, JoinToChatMutationVariables>;
export const SendMessageDocument = gql`
    mutation SendMessage($groupMessage: GroupMessage!) {
  sendGroupMessage(groupMessage: $groupMessage) {
    errors
    result
  }
}
    `;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      groupMessage: // value for 'groupMessage'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const UpdateMessageDocument = gql`
    mutation UpdateMessage($user: String!, $content: String!, $messageId: String!) {
  updateMessageContent(messageId: $messageId, content: $content, user: $user) {
    errors
    result
  }
}
    `;
export type UpdateMessageMutationFn = Apollo.MutationFunction<UpdateMessageMutation, UpdateMessageMutationVariables>;

/**
 * __useUpdateMessageMutation__
 *
 * To run a mutation, you first call `useUpdateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageMutation, { data, loading, error }] = useUpdateMessageMutation({
 *   variables: {
 *      user: // value for 'user'
 *      content: // value for 'content'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useUpdateMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMessageMutation, UpdateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMessageMutation, UpdateMessageMutationVariables>(UpdateMessageDocument, options);
      }
export type UpdateMessageMutationHookResult = ReturnType<typeof useUpdateMessageMutation>;
export type UpdateMessageMutationResult = Apollo.MutationResult<UpdateMessageMutation>;
export type UpdateMessageMutationOptions = Apollo.BaseMutationOptions<UpdateMessageMutation, UpdateMessageMutationVariables>;
export const SendParticipantCommandDocument = gql`
    mutation SendParticipantCommand($command: ParticipantCommand!) {
  sendParticipantCommand(command: $command) {
    result
  }
}
    `;
export type SendParticipantCommandMutationFn = Apollo.MutationFunction<SendParticipantCommandMutation, SendParticipantCommandMutationVariables>;

/**
 * __useSendParticipantCommandMutation__
 *
 * To run a mutation, you first call `useSendParticipantCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendParticipantCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendParticipantCommandMutation, { data, loading, error }] = useSendParticipantCommandMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useSendParticipantCommandMutation(baseOptions?: Apollo.MutationHookOptions<SendParticipantCommandMutation, SendParticipantCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendParticipantCommandMutation, SendParticipantCommandMutationVariables>(SendParticipantCommandDocument, options);
      }
export type SendParticipantCommandMutationHookResult = ReturnType<typeof useSendParticipantCommandMutation>;
export type SendParticipantCommandMutationResult = Apollo.MutationResult<SendParticipantCommandMutation>;
export type SendParticipantCommandMutationOptions = Apollo.BaseMutationOptions<SendParticipantCommandMutation, SendParticipantCommandMutationVariables>;
export const FileUploadConfigDocument = gql`
    query FileUploadConfig {
  serverInfo {
    fileUpload {
      enabled
      maximumFileSize
    }
  }
}
    `;

/**
 * __useFileUploadConfigQuery__
 *
 * To run a query within a React component, call `useFileUploadConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileUploadConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileUploadConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useFileUploadConfigQuery(baseOptions?: Apollo.QueryHookOptions<FileUploadConfigQuery, FileUploadConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FileUploadConfigQuery, FileUploadConfigQueryVariables>(FileUploadConfigDocument, options);
      }
export function useFileUploadConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FileUploadConfigQuery, FileUploadConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FileUploadConfigQuery, FileUploadConfigQueryVariables>(FileUploadConfigDocument, options);
        }
// @ts-ignore
export function useFileUploadConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FileUploadConfigQuery, FileUploadConfigQueryVariables>): Apollo.UseSuspenseQueryResult<FileUploadConfigQuery, FileUploadConfigQueryVariables>;
export function useFileUploadConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FileUploadConfigQuery, FileUploadConfigQueryVariables>): Apollo.UseSuspenseQueryResult<FileUploadConfigQuery | undefined, FileUploadConfigQueryVariables>;
export function useFileUploadConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FileUploadConfigQuery, FileUploadConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FileUploadConfigQuery, FileUploadConfigQueryVariables>(FileUploadConfigDocument, options);
        }
export type FileUploadConfigQueryHookResult = ReturnType<typeof useFileUploadConfigQuery>;
export type FileUploadConfigLazyQueryHookResult = ReturnType<typeof useFileUploadConfigLazyQuery>;
export type FileUploadConfigSuspenseQueryHookResult = ReturnType<typeof useFileUploadConfigSuspenseQuery>;
export type FileUploadConfigQueryResult = Apollo.QueryResult<FileUploadConfigQuery, FileUploadConfigQueryVariables>;
export const MessagesDocument = gql`
    subscription Messages($user: String!, $roomId: String!) {
  message(user: $user, roomId: $roomId) {
    receiver
    sender
    date
    messageId
    status
    deleted
    contentType
    content
    updated
    roomId
    metaInfo
  }
}
    `;

/**
 * __useMessagesSubscription__
 *
 * To run a query within a React component, call `useMessagesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMessagesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesSubscription({
 *   variables: {
 *      user: // value for 'user'
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useMessagesSubscription(baseOptions: Apollo.SubscriptionHookOptions<MessagesSubscription, MessagesSubscriptionVariables> & ({ variables: MessagesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<MessagesSubscription, MessagesSubscriptionVariables>(MessagesDocument, options);
      }
export type MessagesSubscriptionHookResult = ReturnType<typeof useMessagesSubscription>;
export type MessagesSubscriptionResult = Apollo.SubscriptionResult<MessagesSubscription>;
export const ChatParticipantInfoDocument = gql`
    subscription ChatParticipantInfo($roomId: String!) {
  chatParticipantInfo(roomId: $roomId) {
    participant
    isAdmin
    additionalInfo {
      handRaised
      isMuted
      name
      unmuteAllowed
    }
  }
}
    `;

/**
 * __useChatParticipantInfoSubscription__
 *
 * To run a query within a React component, call `useChatParticipantInfoSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatParticipantInfoSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatParticipantInfoSubscription({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useChatParticipantInfoSubscription(baseOptions: Apollo.SubscriptionHookOptions<ChatParticipantInfoSubscription, ChatParticipantInfoSubscriptionVariables> & ({ variables: ChatParticipantInfoSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChatParticipantInfoSubscription, ChatParticipantInfoSubscriptionVariables>(ChatParticipantInfoDocument, options);
      }
export type ChatParticipantInfoSubscriptionHookResult = ReturnType<typeof useChatParticipantInfoSubscription>;
export type ChatParticipantInfoSubscriptionResult = Apollo.SubscriptionResult<ChatParticipantInfoSubscription>;